import { createStageResult, createSufficiencyPayload } from './contracts';

// Evaluates retrieval sufficiency and returns normalized sufficiency stage payload.
export const executeSufficiencyStage = ({
  userText = '',
  intent = null,
  retrieval = null,
  config = {},
  evaluateSufficiency
} = {}) => {
  if (typeof evaluateSufficiency !== 'function') {
    throw new Error('executeSufficiencyStage requires evaluateSufficiency function');
  }

  const sufficiency = evaluateSufficiency({
    userText,
    items: retrieval?.items,
    retrievalMeta: retrieval?.meta,
    intentKey: intent?.key || 'ask',
    minItems: config.minItems,
    minChars: config.minChars,
    minCoverageRatio: config.minCoverageRatio,
    minMatchedKeywords: config.minMatchedKeywords
  });

  return {
    sufficiency,
    sufficiencyResult: createStageResult({
      stage: 'sufficiency',
      status: sufficiency?.isSufficient ? 'sufficient' : 'insufficient',
      decisionCode: sufficiency?.decisionCode || 'unknown',
      reasonCodes: Array.isArray(sufficiency?.reasonCodes) ? sufficiency.reasonCodes : [],
      payload: createSufficiencyPayload({
        score: sufficiency?.score,
        selectedCount: sufficiency?.selectedCount,
        selectedChars: sufficiency?.selectedChars,
        exhaustiveRequested: sufficiency?.exhaustiveRequested,
        topDoc: sufficiency?.topDoc,
        topDocShare: sufficiency?.topDocShare,
        keywordCoverage: sufficiency?.keywordCoverage,
        thresholds: sufficiency?.thresholds
      })
    })
  };
};

// Plans refine queries when sufficiency is low and returns refine planning payload.
export const executeRefineStage = ({
  queryPlan,
  sufficiency,
  userText = '',
  buildRefinePlan
} = {}) => {
  if (typeof buildRefinePlan !== 'function') {
    throw new Error('executeRefineStage requires buildRefinePlan function');
  }

  const refinedQueryPlan = buildRefinePlan({
    queryPlan,
    sufficiency,
    userText
  });

  return {
    refinedQueryPlan,
    refineResult: createStageResult({
      stage: 'refine',
      status: 'ok',
      decisionCode: 'refine_planned',
      payload: {
        addedQueries: Array.isArray(refinedQueryPlan?.refine?.addedQueries)
          ? refinedQueryPlan.refine.addedQueries
          : []
      }
    })
  };
};
